/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var creditBounds = makeEntityScaffold('SAGA.API.CREDIT_BOUNDS', function (client) {
  return client.credits.getBounds().then(function (data) {
    return data.credit_bounds_by_msa;
  });
});